import {getUrlParams} from '../../_web/utils/url'
import {hasUnlockPlusTokenInUrl} from '../../offer/business/privateDeals'

export const useHasUnlockPlusTokenInUrl = () => {
  const urlParams = getUrlParams()
  return hasUnlockPlusTokenInUrl(urlParams)
}
